import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

const Stats = ({ stats }) => {
  const { t } = useLang();

  return (
    <section
      data-testid="stats-section"
      className="py-16 md:py-24 border-b border-white/10"
    >
      <div className="container-hk">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <div className="text-[10px] md:text-xs tracking-[0.35em] text-[var(--hk-red)] font-bold mb-3">
              // 001
            </div>
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl uppercase leading-none">
              {t.stats.title}
            </h2>
          </div>
          <p className="text-sm text-white/60 max-w-sm">{t.stats.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          <StatTile label="TOTAL LIFETIME TIPS" value="3,000+" testid="stat-total" delay={0} />
          <StatTile label="AVG DOUBLE ODDS" value="2.80" testid="stat-avg-odds" delay={0.08} />
          <StatTile label="TIPSTER" value="MR. HAKAN" testid="stat-tipster-name" delay={0.16} withAvatar />
          <StatTile label="EXPERIENCE" value="15+ YEARS" testid="stat-experience" delay={0.24} />
        </div>

        <div className="mt-10 md:mt-14 flex justify-center">
          <button
            onClick={() => {
              const el = document.getElementById("free-tip");
              if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            data-testid="stats-free-tips-btn"
            className="btn-outline px-10 py-4 text-[11px] font-bold tracking-[0.3em]"
          >
            {t.stats.free_tips_btn} →
          </button>
        </div>
      </div>
    </section>
  );
};

const StatTile = ({ label, value, testid, delay = 0, withAvatar = false }) => (
  <motion.div
    data-testid={testid}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ delay, duration: 0.7 }}
    className="bg-black p-6 md:p-8 relative group overflow-hidden"
  >
    <div className="text-[10px] tracking-[0.3em] text-white/50 mb-4">{label}</div>
    {withAvatar ? (
      <div className="flex items-center gap-3">
        <img
          src="/mr-hakan-avatar.jpg"
          alt="Mr. Hakan"
          data-testid="stat-tipster-avatar"
          className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover ring-2 ring-[var(--hk-red)]/70 shrink-0"
        />
        <span className="font-display text-2xl md:text-3xl tracking-tight">{value}</span>
      </div>
    ) : (
      <div className="font-display text-3xl md:text-5xl tracking-tight">{value}</div>
    )}
    <div
      aria-hidden
      className="absolute bottom-0 left-0 h-[2px] w-0 bg-[var(--hk-red)] group-hover:w-full transition-[width] duration-500"
    />
  </motion.div>
);

export default Stats;
